import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { isNullOrUndefinedOrEmpty } from '../../../../../../helpers/common';
import { propArrayShape, propBool, propFunc, propStr, } from '../../../../../../helpers/custom-prop-types';
import SlideSearchShareItem from '../../../SlideItem/Share';
import SlideSearchShareItemSkeleton from '../../../SlideItem/Share/SlideSearchShareItemSkeleton';
import SlideSearchShareStatusTabContentEmpty from './SlideSearchShareStatusTabContentEmpty';
/**
 * タブのスライド共有部分を表示するコンポーネント
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const SlideSearchShareStatusTabContentShare = (props) => {
    const { isShareHistoryOnePage, items, onClickItem, paramId, skeletons } = props;
    // データの初回読み込み中
    if (isNullOrUndefinedOrEmpty(items)) {
        return skeletons.map((v) => _jsx(SlideSearchShareItemSkeleton, {}, v.index));
    }
    // 読み込み後、データが存在しなかった場合
    if (!items.length) {
        return (_jsx(SlideSearchShareStatusTabContentEmpty, { text: 'まだ共有したスライドはありません' }));
    }
    return items.map((v) => (_jsx(SlideSearchShareItem, { isNoLink: v.id === paramId && isShareHistoryOnePage, item: v, onClickNoLink: onClickItem }, v.id)));
};
SlideSearchShareStatusTabContentShare.propTypes = {
    isShareHistoryOnePage: propBool().isRequired,
    items: propArrayShape(),
    onClickItem: propFunc(),
    paramId: propStr(),
    skeletons: propArrayShape().isRequired,
};
SlideSearchShareStatusTabContentShare.defaultProps = {
    items: null,
    onClickItem: undefined,
    paramId: '',
};
export default SlideSearchShareStatusTabContentShare;
